export abstract class StorageService {
  protected readonly STORAGE_KEY = 'IONIC_STORAGE_APP_STATE';

  public abstract init(): Promise<void>;

  public abstract set(key: string, value: any): Promise<void>;

  public abstract get(key: string): Promise<any>;

  public abstract remove(key: string): Promise<void>;

  public abstract clear(): Promise<void>;

  public abstract keys(): Promise<string[]>;

  public abstract fetchState(): Promise<{}>;
}
